class QuickAddVariant {
  constructor() {
    this.init();
  }

  init() {
    const quickAddButtons = document.querySelectorAll('.quick-add-button');
    const variantSelects = document.querySelectorAll('.variant-select');
    
    quickAddButtons.forEach(button => {
      button.addEventListener('click', (e) => this.handleAddToCart(e));
    });

    variantSelects.forEach(select => {
      select.addEventListener('change', (e) => this.handleVariantChange(e));
    });
  }

  handleVariantChange(e) {
    const select = e.currentTarget;
    const container = select.closest('.quick-add-variant');
    const selectedOption = select.options[select.selectedIndex];
    

    const price = selectedOption.dataset.price;
    const comparePrice = selectedOption.dataset.comparePrice;
    
    this.updatePrice(container, price, comparePrice);
    
    const button = container.querySelector('.quick-add-button');
    if (selectedOption.disabled) {
      button.disabled = true;
      button.querySelector('.button-text').textContent = 'Sold out';
    } else {
      button.disabled = false;
      button.querySelector('.button-text').textContent = 'Add to cart';
    }
  }

  updatePrice(container, price, comparePrice) {
    const priceElement = container.querySelector('[data-variant-price]');
    const comparePriceElement = container.querySelector('[data-variant-compare-price]');
    const priceWrapper = container.querySelector('[data-price-wrapper]');
    
    if (!priceElement) return;
    
    const formattedPrice = this.formatMoney(price);
    priceElement.textContent = formattedPrice;
    
    if (comparePrice && parseInt(comparePrice) > parseInt(price)) {
      const formattedComparePrice = this.formatMoney(comparePrice);
      
      if (comparePriceElement) {
        comparePriceElement.textContent = formattedComparePrice;
        comparePriceElement.style.display = 'inline';
      } else {

        const newComparePrice = document.createElement('span');
        newComparePrice.className = 'price-item price-item--sale';
        newComparePrice.dataset.variantComparePrice = '';
        newComparePrice.textContent = formattedComparePrice;
        priceWrapper.appendChild(newComparePrice);
      }
      
      priceElement.classList.add('price-item--on-sale');
    } else {
      if (comparePriceElement) {
        comparePriceElement.style.display = 'none';
      }
      priceElement.classList.remove('price-item--on-sale');
    }
  }

  formatMoney(cents) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    
    const format = '${{amount}}'; //window.Shopify?.currency?.active

    const value = (parseFloat(cents) / 100).toFixed(0);
    
    const formattedValue = value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    
    return format.replace('{{amount}}', formattedValue);
  }

  async handleAddToCart(e) {
    const button = e.currentTarget;
    const container = button.closest('.quick-add-variant');
    const select = container.querySelector('.variant-select');
    const variantId = select ? select.value : button.dataset.variantId;
    const buttonText = button.querySelector('.button-text');
    const buttonLoading = button.querySelector('.button-loading');
    const messageDiv = container.querySelector('.quick-add-message');

    button.disabled = true;
    if (buttonText) buttonText.style.display = 'none';
    if (buttonLoading) buttonLoading.style.display = 'inline-block';

    try {
      // Add to cart
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      });

      if (!response.ok) {
        throw new Error('Failed to add to cart');
      }

      const data = await response.json();

      await this.updateCartCount();

      this.showMessage(messageDiv, 'Added to cart!', 'success');

      document.dispatchEvent(new CustomEvent('cart:item-added', { 
        detail: data 
      }));

      this.openCartDrawer();

      this.openCartNotification(data);

    } catch (error) {
      console.error('Error:', error);
      this.showMessage(messageDiv, 'Failed to add to cart', 'error');
    } finally {
      // Reset button
      button.disabled = false;
      if (buttonText) buttonText.style.display = 'inline';
      if (buttonLoading) buttonLoading.style.display = 'none';
    }
  }

  async updateCartCount() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      const cartCountBubbles = document.querySelectorAll('.cart-count-bubble');
      const cartCountElements = document.querySelectorAll('[data-cart-count]');
      
      cartCountBubbles.forEach(bubble => {
        const span = bubble.querySelector('span');
        if (span) {
          span.textContent = cart.item_count;
        }
        
        if (cart.item_count > 0) {
          bubble.classList.remove('hidden');
          bubble.style.display = '';
          
          bubble.classList.remove('visibility-hidden');
          bubble.removeAttribute('hidden');
        }
      });

      cartCountElements.forEach(element => {
        element.textContent = cart.item_count;
        element.setAttribute('data-cart-count', cart.item_count);
        
        if (cart.item_count > 0) {
          element.style.display = '';
          element.classList.remove('hidden');
        }
      });

      const cartBadges = document.querySelectorAll('.cart-badge, [data-cart-badge]');
      cartBadges.forEach(badge => {
        badge.textContent = cart.item_count;
        if (cart.item_count > 0) {
          badge.classList.remove('hidden');
          badge.style.display = '';
        }
      });

      const cartIcon = document.querySelector('#cart-icon-bubble');
      if (cartIcon) {
        cartIcon.classList.add('cart-updated');
        setTimeout(() => {
          cartIcon.classList.remove('cart-updated');
        }, 300);
      }

      document.documentElement.dispatchEvent(
        new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: cart
        })
      );

    } catch (error) {
      console.error('Error updating cart count:', error);
    }
  }

  openCartDrawer() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      cartDrawer.open();
    }
    
    const cartLink = document.querySelector('a[href="/cart"]');
    if (cartLink && cartDrawer) {
      const event = new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window
      });
      cartLink.dispatchEvent(event);
    }
  }

  openCartNotification(cartItem) {
    const cartNotification = document.querySelector('cart-notification');
    if (cartNotification) {
      cartNotification.open();
    }
  }

  showMessage(messageDiv, text, type) {
    if (!messageDiv) return;

    messageDiv.textContent = text;
    messageDiv.className = `quick-add-message quick-add-message--${type}`;
    messageDiv.style.display = 'block';

    setTimeout(() => {
      messageDiv.style.display = 'none';
    }, 3000);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new QuickAddVariant();
  });
} else {
  new QuickAddVariant();
}

document.addEventListener('shopify:section:load', () => {
  new QuickAddVariant();
});